// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"HowToStart_parentContainer__DC4LR"};